var map = {
	"./ananya.jpeg": "f288",
	"./ashwin.jpeg": "702d",
	"./dhaanvi.jpeg": "8df3",
	"./kavya.jpeg": "04a2",
	"./reya.jpeg": "1ea3",
	"./rushil.jpeg": "02d9",
	"./saurvi.jpeg": "43bc",
	"./vanessa.jpeg": "bf16"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "371c";